import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { useState } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { normalizeFormValues } from '@/features/dialogs/common/logic/transfer-from-user/form'
import { SavingsConverter } from '@/features/savings/logic/savings-converters/types'

export interface UseShouldRedeemParams {
  converter: SavingsConverter
  savingsTokenBalance: NormalizedNumber
  tokenRepository: TokenRepository
  form: UseFormReturn<AssetInputSchema>
}

export interface UseShouldRedeemResult {
  shouldRedeem: boolean
  onMaxSet: (value: NormalizedNumber) => void
}

export function useShouldRedeem({
  converter,
  savingsTokenBalance,
  tokenRepository,
  form,
}: UseShouldRedeemParams): UseShouldRedeemResult {
  const [shouldRedeem, setShouldRedeem] = useState(false)
  const formValues = normalizeFormValues(form.watch(), tokenRepository) // we need here not debounced data

  function onMaxSet(value: NormalizedNumber): void {
    const redeemAssetsAmount = converter.convertToAssets({ shares: savingsTokenBalance })
    setShouldRedeem(value.eq(redeemAssetsAmount))
  }

  return {
    shouldRedeem: shouldRedeem && formValues.isMaxSelected,
    onMaxSet,
  }
}
